// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1JxCu","inputWrap":"Table_inputWrap__3ko0z","col":"Table_col__J-EKt","bmiTooltip":"Table_bmiTooltip__sHTI0"};